angular.module('picmonicng').factory('FalseBountyResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/false_bounty/:false_bounty_id',
      { false_bounty_id: '@false_bounty_id' },
      {
        get: { method: 'GET', isArray: false },
      }
    );
  },
]);
